import { render } from "./ManualStepDataEdit.vue?vue&type=template&id=3a024872"
import script from "./ManualStepDataEdit.vue?vue&type=script&lang=js"
export * from "./ManualStepDataEdit.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__